import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface NavigationButtonProps {
  navAction?: "next" | "back";
}

export default styled.button<NavigationButtonProps>`
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  outline: none;
  background: transparent;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  cursor: normal;

  &:only-child {
    margin-left: ${({ navAction }) => (navAction === "next" ? "auto" : 0)};
  }

  @media screen and (min-width: ${DESKTOP}px) {
    cursor: pointer;
  }
`;
